import { Pipe, PipeTransform } from '@angular/core';
import { VorgangsTyp } from 'src/app/domain/model/vorgangsTyp';

@Pipe({
    name: 'aufgabeTypeFristPrefix',
    standalone: false,
})
export class AufgabeTypeFristPrefixPipe implements PipeTransform {

    transform(value: VorgangsTyp): any {
        switch (value) {
            case VorgangsTyp.AUFGABE: return 'Frist bis';
            case VorgangsTyp.INFORMATION: return 'Datum';
            case VorgangsTyp.TERMIN: return 'Datum';
            case VorgangsTyp.GESAMTLAST: return 'Datum';
            case VorgangsTyp.ABWURFPUNKTE_INFORMATION: return 'Datum';
            case VorgangsTyp.ABWURFPUNKTE_AUFGABE: return 'Frist bis';
            default: return 'Unbekannter Aufgabentyp';
        }
    }

}
